import { getArrayFromTree } from '@shape-ds/components';
import { ActionStatus, BaseAsset } from 'queries/assets/contract';
import { findByAssetNameRecursive } from 'utils/Trail';

export const checkHasSpecialCharacter = (value: string) => {
  const regex = /^[a-zA-Z0-9-_à-úÀ-Ú ]*$/;

  return !regex.test(value);
};

export const getAreSavingsFieldsComplete = (
  isSavingsYesNoEnabled: boolean,
  watch: (field: string) => string,
  isOpen: boolean,
  savingsFieldsWatch: Array<any>,
) => {
  if (!isSavingsYesNoEnabled) return true;

  if (watch('action_status') === ActionStatus.CANCELED) return true;

  if (
    isOpen &&
    (watch('action_status') === ActionStatus.ACTION_ISSUED ||
      watch('action_status') === ActionStatus.COMPLETED)
  ) {
    return savingsFieldsWatch.every(Boolean);
  }

  if (watch('action_status') === ActionStatus.INVESTIGATING) {
    return !!(watch('savings.description') && watch('savings.equipment_class'));
  }

  return false;
};
export const getOptionsFromAssetChildren = (
  tree?: BaseAsset[],
  assets?: {
    name?: string;
    id: string;
  }[],
) => {
  if (assets && assets?.length > 0 && tree) {
    return assets.flatMap((asset) => {
      const parent = findByAssetNameRecursive(tree, asset.name)?.item;

      return getArrayFromTree(parent ? [parent] : []);
    });
  }

  return getArrayFromTree(tree ?? []);
};
